<template>
  <div class="network-rule-specific-info-card">
    <tabs
      :tabs="tabs"
      :active-tab="activeTab"
      :tabs-styling="tabsStyling"
      :tabs-labels-styling="tabsLabelsStyling"
      :center-tabs="false"
      @startTabChange="activeTab = $event"
    />
    <div :style="{'height': 'calc(100% - 60px)', 'margin-top': '21px', 'overflow-y': 'auto', 'overflow-x': 'hidden' }">
      <fields-list
        :fields="selectedTabFields"
        :editing-data="editingData"
        @update-field="$emit('update-specific-field', $event)"
      />
    </div>
    <div v-if="editingData" class="action-buttons">
      <custom-button
        :label="$t('Cancel')"
        :button-color="'#FFF'"
        :label-color="'#29BDF0'"
        :button-styling="actionButtonsStyling"
        @buttonClick="$emit('cancel-edit')"
      />
      <custom-button
        :label="$t(submitButtonLabel)"
        :button-color="'#29BDF0'"
        :label-color="'#FFF'"
        :button-styling="actionButtonsStylingSave"
        :disabled="typeof requiredFieldsFilled === 'boolean' ? !requiredFieldsFilled : true"
        @buttonClick="$emit('save-material')"
      />
      <!-- não copiar o disabled, é prego porque o Vue é burro -->
    </div>
  </div>
</template>

<script>
import Tabs from '@/newComponents/_Atoms/Tabs.vue';
import Table from '@/newComponents/_Molecules/Table';
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";
import CustomButton from '@/newComponents/_Atoms/CustomButton.vue';
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import { mapActions } from "vuex";
import { unitConverterMixin } from "@/mixins/management/unitConverterMixin";

export default {
  name: "NetworkRuleSpecificInfo",

  components: {
    Tabs,
    Table,
    FieldsList,
    CustomButton,
  },

  mixins: [objectManagementMixin, unitConverterMixin],

  props: {
    networkRuleData: {
      type: Object,
      required: true,
    },

    networkRuleId: {
      type: Number,
      required: false,
    },

    editingData: {
      type: Boolean,
      required: true,
    },

    requiredFieldsFilled: {
      type: Boolean,
      required: true,
      default: false
    },

    submitButtonLabel: {
      type: String,
    },
  },

  data() {
    return {
      activeTab: 0,
      tabsStyling: {
        'margin': '0px 0px 8px 0px',
        'width': '100%',
        'height': '39px',
      },
      tabsLabelsStyling: {
        'text-transform': 'none',
        'font-size': '10px',
        'letter-spacing': '0',
      },
      actionButtonsStyling: {
        'border': '1px solid #29BDF0',
        'border-radius': '7px',
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
      actionButtonsStylingSave: {
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
      loading: false,
      splitterOptions: [],
      cableOptions: [],
      closureOptions: [],
      verticalAuxiliaryOptions: [],
    }
  },

  mounted() {
    if (!this.requiredFieldsFilled) {
      this.activeTab = 1;
    }

    this.loadAllOptionsLists();
  },

  computed: {
    tabs() {
      return [
        { id: 'network_whole', label: this.$i18n.t("NetworkWhole") },
        { id: 'feeder_network', label: this.$i18n.t("FeederNetwork") },
        { id: 'distribution_network', label: this.$i18n.t("DistributionNetwork") },
        { id: 'drop_network', label: this.$i18n.t("DropNetwork") },
        { id: 'vertical_network', label: this.$i18n.t("VerticalNetwork") },
        { id: 'subscribers', label: this.$i18n.t("Subscribers") },
      ]
    },

    networkWholeFields() {
      return [
        {
          label: this.$i18n.t("FibersPerTube"),
          value: this.networkRuleData.fibers_per_tube,
          varName: 'fibers_per_tube',
          inputType: 'number',
          disabled: false,
          required: true,
          step: '1',
          min: '1',
          // placeholder: this.$i18n.t("MultipleOf") + ' 3'
        },
        {
          label: this.$i18n.t("CabinetLossValue"),
          value: this.networkRuleData.loss_value_cabinet,
          varName: 'loss_value_cabinet',
          inputType: 'number',
          disabled: false,
          required: false,
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
        {
          label: this.$i18n.t("DistributionCableLossValue"),
          value: this.networkRuleData.loss_value_cable,
          varName: 'loss_value_cable',
          inputType: 'number',
          disabled: false,
          required: false,
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
        {
          label: this.$i18n.t("HarnessCableLossValue"),
          value: this.networkRuleData.loss_value_harness_cable,
          varName: 'loss_value_harness_cable',
          inputType: 'number',
          disabled: false,
          required: false,
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
        {
          label: this.$i18n.t("DropCableLossValue"),
          value: this.networkRuleData.loss_value_drop_cable,
          varName: 'loss_value_drop_cable',
          inputType: 'number',
          disabled: false,
          required: false,
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
        {
          label: this.$i18n.t("SpliceLossValue"),
          value: this.networkRuleData.loss_value_splice,
          varName: 'loss_value_splice',
          inputType: 'number',
          disabled: false,
          required: false,
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
        {
          label: this.$i18n.tc("Splice") + ' 1:2 ' + this.$i18n.t('LossValue'),
          value: this.networkRuleData.loss_value_splitter_1_2,
          varName: 'loss_value_splitter_1_2',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
        {
          label: this.$i18n.tc("Splice") + ' 1:2 ' + this.$i18n.t('LossValueInCascade'),
          value: this.networkRuleData.loss_value_splitter_1_2_cascade,
          varName: 'loss_value_splitter_1_2_cascade',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
        {
          label: this.$i18n.tc("Splice") + ' 1:4 ' + this.$i18n.t('LossValue'),
          value: this.networkRuleData.loss_value_splitter_1_4,
          varName: 'loss_value_splitter_1_4',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
        {
          label: this.$i18n.tc("Splice") + ' 1:4 ' + this.$i18n.t('LossValueInCascade'),
          value: this.networkRuleData.loss_value_splitter_1_4_cascade,
          varName: 'loss_value_splitter_1_4_cascade',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
        {
          label: this.$i18n.tc("Splice") + ' 1:8 ' + this.$i18n.t('LossValue'),
          value: this.networkRuleData.loss_value_splitter_1_8,
          varName: 'loss_value_splitter_1_8',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
        {
          label: this.$i18n.tc("Splice") + ' 1:8 ' + this.$i18n.t('LossValueInCascade'),
          value: this.networkRuleData.loss_value_splitter_1_8_cascade,
          varName: 'loss_value_splitter_1_8_cascade',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
        {
          label: this.$i18n.tc("Splice") + ' 1:12 ' + this.$i18n.t('LossValue'),
          value: this.networkRuleData.loss_value_splitter_1_12,
          varName: 'loss_value_splitter_1_12',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
        {
          label: this.$i18n.tc("Splice") + ' 1:12 ' + this.$i18n.t('LossValueInCascade'),
          value: this.networkRuleData.loss_value_splitter_1_12_cascade,
          varName: 'loss_value_splitter_1_12_cascade',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
        {
          label: this.$i18n.tc("Splice") + ' 1:16 ' + this.$i18n.t('LossValue'),
          value: this.networkRuleData.loss_value_splitter_1_16,
          varName: 'loss_value_splitter_1_16',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
        {
          label: this.$i18n.tc("Splice") + ' 1:16 ' + this.$i18n.t('LossValueInCascade'),
          value: this.networkRuleData.loss_value_splitter_1_16_cascade,
          varName: 'loss_value_splitter_1_16_cascade',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.00001',
          min: '0.00001',
          max: '1',
        },
      ]
    },

    feederNetworkFields() {
      return [
        {
          label: this.$i18n.tc("Equipment", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.feeder_splitters_list, this.splitterOptions)
            : this.networkRuleData.feeder_splitters_list,
          varName: 'feeder_splitters_list',
          inputType: 'multiselect',
          disabled: false,
          required: false,
          size: '100%',
          options: this.splitterOptions,
          clearable: true,
        },
        {
          label: this.$i18n.t("MaximumNumberSplitters"),
          value: this.networkRuleData.feeder_max_splitters,
          varName: 'feeder_max_splitters',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
        },
        {
          label: !this.editingData ? this.$i18n.t("AllowFibersOutsideSplitters") : '',
          value: !this.editingData
           ? this.networkRuleData.feeder_allow_fibers_out_splitters === true ? this.$i18n.t('Yes') : this.$i18n.t('No')
           : this.networkRuleData.feeder_allow_fibers_out_splitters,
          varName: 'feeder_allow_fibers_out_splitters',
          inputType: 'checkbox',
          disabled: false,
          required: false,
          size: '50%',
          checkboxOptions: [
            {
              id: 'allow_fibers',
              label: this.$i18n.t("AllowFibersOutsideSplitters"),
            }
          ]
        },
        {
          label: this.$i18n.t('MaintenanceFibersRule'),
          value: !this.editingData
           ? this.parseRadioValue(this.networkRuleData.feeder_maintenance_mode, this.maintenanceFibersRuleOptions)
           : this.networkRuleData.feeder_maintenance_mode,
          varName: 'feeder_maintenance_mode',
          inputType: 'radio',
          disabled: false,
          required: false,
          size: '50%',
          radioOptions: this.maintenanceFibersRuleOptions,
        },
        {
          label: this.networkRuleData.feeder_maintenance_mode === 'percentage'
            ? this.$i18n.t("PercentageOfFibers")
            : this.$i18n.t("NumberOfFibers"),
          value: this.networkRuleData.feeder_maintenance_value,
          varName: 'feeder_maintenance_value',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
          max: this.networkRuleData.feeder_maintenance_mode === 'percentage' ? 100 : undefined
        },
        {
          label: this.$i18n.t('ExtraFibersRule'),
          value: !this.editingData
           ? this.parseRadioValue(this.networkRuleData.feeder_extra_mode, this.maintenanceFibersRuleOptions)
           : this.networkRuleData.feeder_extra_mode,
          varName: 'feeder_extra_mode',
          inputType: 'radio',
          disabled: false,
          required: false,
          size: '50%',
          radioOptions: this.maintenanceFibersRuleOptions,
        },
        {
          label: this.networkRuleData.feeder_extra_mode === 'percentage'
            ? this.$i18n.t("PercentageOfFibers")
            : this.$i18n.t("NumberOfFibers"),
          value: this.networkRuleData.feeder_extra_value,
          varName: 'feeder_extra_value',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
          max: this.networkRuleData.feeder_extra_mode === 'percentage' ? 100 : undefined
        },
        {
          label: this.$i18n.tc("FeederCable", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.feeder_cable_materials_list, this.cableOptions)
            : this.networkRuleData.feeder_cable_materials_list,
          varName: 'feeder_cable_materials_list',
          inputType: 'multiselect',
          disabled: false,
          required: false,
          size: '50%',
          options: this.cableOptions,
          clearable: true,
        },
        {
          label: this.$i18n.t("MaxCableLength") + this.getUnitLabel("m"),
          value: this.networkRuleData.feeder_max_cable_length,
          varName: 'feeder_max_cable_length',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.01',
          min: '0',
        },
        {
          label: this.$i18n.tc("Closure", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.feeder_closures_list, this.closureOptions)
            : this.networkRuleData.feeder_closures_list,
          varName: 'feeder_closures_list',
          inputType: 'multiselect',
          disabled: false,
          required: false,
          size: '100%',
          options: this.closureOptions,
          clearable: true,
        },
      ]
    },

    distributionNetworkFields() {
      return [
        {
          label: this.$i18n.tc("Equipment", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.distribution_splitters_list, this.splitterOptions)
            : this.networkRuleData.distribution_splitters_list,
          varName: 'distribution_splitters_list',
          inputType: 'multiselect',
          disabled: false,
          required: false,
          size: '100%',
          options: this.splitterOptions,
          clearable: true,
        },
        {
          label: this.$i18n.t("MaximumNumberSplitters"),
          value: this.networkRuleData.distribution_max_splitters,
          varName: 'distribution_max_splitters',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
        },
        {
          label: !this.editingData ? this.$i18n.t("AllowFibersOutsideSplitters") : '',
          value: !this.editingData
           ? this.networkRuleData.distribution_allow_fibers_out_splitters === true ? this.$i18n.t('Yes') : this.$i18n.t('No')
           : this.networkRuleData.distribution_allow_fibers_out_splitters,
          varName: 'distribution_allow_fibers_out_splitters',
          inputType: 'checkbox',
          disabled: false,
          required: false,
          size: '50%',
          checkboxOptions: [
            {
              id: 'allow_fibers',
              label: this.$i18n.t("AllowFibersOutsideSplitters"),
            }
          ]
        },
        {
          label: this.$i18n.t('MaintenanceFibersRule'),
          value: !this.editingData
           ? this.parseRadioValue(this.networkRuleData.distribution_maintenance_mode, this.maintenanceFibersRuleOptions)
           : this.networkRuleData.distribution_maintenance_mode,
          varName: 'distribution_maintenance_mode',
          inputType: 'radio',
          disabled: false,
          required: false,
          size: '50%',
          radioOptions: this.maintenanceFibersRuleOptions,
        },
        {
          label: this.networkRuleData.distribution_maintenance_mode === 'percentage'
            ? this.$i18n.t("PercentageOfFibers")
            : this.$i18n.t("NumberOfFibers"),
          value: this.networkRuleData.distribution_maintenance_value,
          varName: 'distribution_maintenance_value',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
          max: this.networkRuleData.distribution_maintenance_mode === 'percentage' ? 100 : undefined
        },
        {
          label: this.$i18n.t('ExtraFibersRule'),
          value: !this.editingData
           ? this.parseRadioValue(this.networkRuleData.distribution_extra_mode, this.maintenanceFibersRuleOptions)
           : this.networkRuleData.distribution_extra_mode,
          varName: 'distribution_extra_mode',
          inputType: 'radio',
          disabled: false,
          required: false,
          size: '50%',
          radioOptions: this.maintenanceFibersRuleOptions,
        },
        {
          label: this.networkRuleData.distribution_extra_mode === 'percentage'
            ? this.$i18n.t("PercentageOfFibers")
            : this.$i18n.t("NumberOfFibers"),
          value: this.networkRuleData.distribution_extra_value,
          varName: 'distribution_extra_value',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
          max: this.networkRuleData.distribution_extra_mode === 'percentage' ? 100 : undefined
        },
        {
          label: this.$i18n.tc("DistributionCable", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.distribution_cable_materials_list, this.cableOptions)
            : this.networkRuleData.distribution_cable_materials_list,
          varName: 'distribution_cable_materials_list',
          inputType: 'multiselect',
          disabled: false,
          required: false,
          size: '50%',
          options: this.cableOptions,
          clearable: true,
        },
        {
          label: this.$i18n.t("MaxCableLength") + this.getUnitLabel("m"),
          value: this.networkRuleData.distribution_max_cable_length,
          varName: 'distribution_max_cable_length',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.01',
          min: '0',
        },
        {
          label: this.$i18n.tc("Closure", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.distribution_closures_list, this.closureOptions)
            : this.networkRuleData.distribution_closures_list,
          varName: 'distribution_closures_list',
          inputType: 'multiselect',
          disabled: false,
          required: false,
          size: '100%',
          options: this.closureOptions,
          clearable: true,
        },
      ]
    },

    dropNetworkFields() {
      return [
        {
          label: this.$i18n.tc("Equipment", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.drop_splitters_list, this.splitterOptions)
            : this.networkRuleData.drop_splitters_list,
          varName: 'drop_splitters_list',
          inputType: 'multiselect',
          disabled: false,
          required: false,
          size: '100%',
          options: this.splitterOptions,
          clearable: true,
        },
        {
          label: this.$i18n.t("MaximumNumberSplitters"),
          value: this.networkRuleData.drop_max_splitters,
          varName: 'drop_max_splitters',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
        },
        {
          label: !this.editingData ? this.$i18n.t("AllowFibersOutsideSplitters") : '',
          value: !this.editingData
           ? this.networkRuleData.drop_allow_fibers_out_splitters === true ? this.$i18n.t('Yes') : this.$i18n.t('No')
           : this.networkRuleData.drop_allow_fibers_out_splitters,
          varName: 'drop_allow_fibers_out_splitters',
          inputType: 'checkbox',
          disabled: false,
          required: false,
          size: '50%',
          checkboxOptions: [
            {
              id: 'allow_fibers',
              label: this.$i18n.t("AllowFibersOutsideSplitters"),
            }
          ]
        },
        {
          label: this.$i18n.t('MaintenanceFibersRule'),
          value: !this.editingData
           ? this.parseRadioValue(this.networkRuleData.drop_maintenance_mode, this.maintenanceFibersRuleOptions)
           : this.networkRuleData.drop_maintenance_mode,
          varName: 'drop_maintenance_mode',
          inputType: 'radio',
          disabled: false,
          required: false,
          size: '50%',
          radioOptions: this.maintenanceFibersRuleOptions,
        },
        {
          label: this.networkRuleData.drop_maintenance_mode === 'percentage'
            ? this.$i18n.t("PercentageOfFibers")
            : this.$i18n.t("NumberOfFibers"),
          value: this.networkRuleData.drop_maintenance_value,
          varName: 'drop_maintenance_value',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
          max: this.networkRuleData.drop_maintenance_mode === 'percentage' ? 100 : undefined
        },
        {
          label: this.$i18n.t('ExtraFibersRule'),
          value: !this.editingData
           ? this.parseRadioValue(this.networkRuleData.drop_extra_mode, this.maintenanceFibersRuleOptions)
           : this.networkRuleData.drop_extra_mode,
          varName: 'drop_extra_mode',
          inputType: 'radio',
          disabled: false,
          required: false,
          size: '50%',
          radioOptions: this.maintenanceFibersRuleOptions,
        },
        {
          label: this.networkRuleData.drop_extra_mode === 'percentage'
            ? this.$i18n.t("PercentageOfFibers")
            : this.$i18n.t("NumberOfFibers"),
          value: this.networkRuleData.drop_extra_value,
          varName: 'drop_extra_value',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
          max: this.networkRuleData.drop_extra_mode === 'percentage' ? 100 : undefined
        },
        {
          label: this.$i18n.tc("DropCable", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.drop_cable_materials_list, this.cableOptions)
            : this.networkRuleData.drop_cable_materials_list,
          varName: 'drop_cable_materials_list',
          inputType: 'multiselect',
          disabled: false,
          required: false,
          size: '50%',
          options: this.cableOptions,
          clearable: true,
        },
        {
          label: this.$i18n.t("MaxCableLength")+ this.getUnitLabel("m"),
          value: this.networkRuleData.drop_max_cable_length,
          varName: 'drop_max_cable_length',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.01',
          min: '0',
        },
        {
          label: this.$i18n.tc("Closure", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.drop_closures_list, this.closureOptions)
            : this.networkRuleData.drop_closures_list,
          varName: 'drop_closures_list',
          inputType: 'multiselect',
          disabled: false,
          required: false,
          size: '100%',
          options: this.closureOptions,
          clearable: true,
        },
      ]
    },

    verticalNetworkFields() {
      return [
        {
          label: this.$i18n.tc("Equipment", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.vertical_splitters_list, this.splitterOptions)
            : this.networkRuleData.vertical_splitters_list,
          varName: 'vertical_splitters_list',
          inputType: 'multiselect',
          disabled: false,
          required: false,
          size: '100%',
          options: this.splitterOptions,
          clearable: true,
        },
        {
          label: this.$i18n.t("MaximumNumberSplitters"),
          value: this.networkRuleData.vertical_max_splitters,
          varName: 'vertical_max_splitters',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
        },
        {
          label: !this.editingData ? this.$i18n.t("AllowFibersOutsideSplitters") : '',
          value: !this.editingData
           ? this.networkRuleData.vertical_allow_fibers_out_splitters === true ? this.$i18n.t('Yes') : this.$i18n.t('No')
           : this.networkRuleData.vertical_allow_fibers_out_splitters,
          varName: 'vertical_allow_fibers_out_splitters',
          inputType: 'checkbox',
          disabled: false,
          required: false,
          size: '50%',
          checkboxOptions: [
            {
              id: 'allow_fibers',
              label: this.$i18n.t("AllowFibersOutsideSplitters"),
            }
          ]
        },
        {
          label: this.$i18n.t('MaintenanceFibersRule'),
          value: !this.editingData
           ? this.parseRadioValue(this.networkRuleData.vertical_maintenance_mode, this.maintenanceFibersRuleOptions)
           : this.networkRuleData.vertical_maintenance_mode,
          varName: 'vertical_maintenance_mode',
          inputType: 'radio',
          disabled: false,
          required: false,
          size: '50%',
          radioOptions: this.maintenanceFibersRuleOptions,
        },
        {
          label: this.networkRuleData.vertical_maintenance_mode === 'percentage'
            ? this.$i18n.t("PercentageOfFibers")
            : this.$i18n.t("NumberOfFibers"),
          value: this.networkRuleData.vertical_maintenance_value,
          varName: 'vertical_maintenance_value',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
          max: this.networkRuleData.vertical_maintenance_mode === 'percentage' ? 100 : undefined
        },
        {
          label: this.$i18n.t('ExtraFibersRule'),
          value: !this.editingData
           ? this.parseRadioValue(this.networkRuleData.vertical_extra_mode, this.maintenanceFibersRuleOptions)
           : this.networkRuleData.vertical_extra_mode,
          varName: 'vertical_extra_mode',
          inputType: 'radio',
          disabled: false,
          required: false,
          size: '50%',
          radioOptions: this.maintenanceFibersRuleOptions,
        },
        {
          label: this.networkRuleData.vertical_extra_mode === 'percentage'
            ? this.$i18n.t("PercentageOfFibers")
            : this.$i18n.t("NumberOfFibers"),
          value: this.networkRuleData.vertical_extra_value,
          varName: 'vertical_extra_value',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
          max: this.networkRuleData.vertical_extra_mode === 'percentage' ? 100 : undefined
        },
        {
          label: this.$i18n.tc("DistributionCable", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.vertical_distribution_cable_materials_list, this.cableOptions)
            : this.networkRuleData.vertical_distribution_cable_materials_list,
          varName: 'vertical_distribution_cable_materials_list',
          inputType: 'multiselect',
          disabled: false,
          required: false,
          size: '50%',
          options: this.cableOptions,
          clearable: true,
        },
        {
          label: this.$i18n.t("MaxCableLength") + this.getUnitLabel("m") ,
          value: this.networkRuleData.vertical_distribution_max_cable_length,
          varName: 'vertical_distribution_max_cable_length',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.01',
          min: '0',
        },
         {
          label: this.$i18n.tc("DropCable", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.vertical_drop_cable_materials_list, this.cableOptions)
            : this.networkRuleData.vertical_drop_cable_materials_list,
          varName: 'vertical_drop_cable_materials_list',
          inputType: 'multiselect',
          disabled: false,
          required: true,
          size: '50%',
          options: this.verticalAuxiliaryOptions,
          clearable: true,
        },
        {
          label: this.$i18n.t("Drop") + " " +this.$i18n.t("MaxCableLength") + this.getUnitLabel("m"),
          value: this.networkRuleData.vertical_drop_max_cable_length,
          varName: 'vertical_drop_max_cable_length',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '.01',
          min: '0',
        },
        {
          label: this.$i18n.tc("Closure", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.vertical_closures_list, this.closureOptions)
            : this.networkRuleData.vertical_closures_list,
          varName: 'vertical_closures_list',
          inputType: 'multiselect',
          disabled: false,
          required: false,
          size: '100%',
          options: this.closureOptions,
          clearable: true,
        },
      ]
    },

    subscribersFields() {
      return [
        {
          label: this.$i18n.tc("Splitter", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.subscriber_splitters_list, this.splitterOptions)
            : this.networkRuleData.subscriber_splitters_list,
          varName: 'subscriber_splitters_list',
          inputType: 'multiselect',
          disabled: false,
          required: false,
          size: '50%',
          options: this.splitterOptions,
          clearable: true,
        },
        {
          label: this.$i18n.t("MaximumNumberSplitters"),
          value: this.networkRuleData.subscriber_max_splitters,
          varName: 'subscriber_max_splitters',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
        },
        {
          label: !this.editingData ? this.$i18n.t("AllowFibersOutsideSplitters") : '',
          value: !this.editingData
           ? this.networkRuleData.subscriber_allow_fibers_out_splitters === true ? this.$i18n.t('Yes') : this.$i18n.t('No')
           : this.networkRuleData.subscriber_allow_fibers_out_splitters,
          varName: 'subscriber_allow_fibers_out_splitters',
          inputType: 'checkbox',
          disabled: false,
          required: false,
          size: '50%',
          checkboxOptions: [
            {
              id: 'allow_fibers',
              label: this.$i18n.t("AllowFibersOutsideSplitters"),
            }
          ]
        },
        {
          label: this.$i18n.tc("Cable", 2),
          value: !this.editingData
            ? this.parseSelectValue(this.networkRuleData.subscriber_cable_materials_list, this.cableOptions)
            : this.networkRuleData.subscriber_cable_materials_list,
          varName: 'subscriber_cable_materials_list',
          inputType: 'multiselect',
          disabled: false,
          required: false,
          size: '50%',
          options: this.cableOptions,
          clearable: true,
        },
        {
          label: this.$i18n.t('MaintenanceFibersRule'),
          value: !this.editingData
           ? this.parseRadioValue(this.networkRuleData.subscriber_maintenance_mode, this.maintenanceFibersRuleOptions)
           : this.networkRuleData.subscriber_maintenance_mode,
          varName: 'subscriber_maintenance_mode',
          inputType: 'radio',
          disabled: false,
          required: false,
          size: '50%',
          radioOptions: this.maintenanceFibersRuleOptions,
        },
        {
          label: this.networkRuleData.subscriber_maintenance_mode === 'percentage'
            ? this.$i18n.t("PercentageOfFibers")
            : this.$i18n.t("NumberOfFibers"),
          value: this.networkRuleData.subscriber_maintenance_value,
          varName: 'subscriber_maintenance_value',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
          max: this.networkRuleData.subscriber_maintenance_mode === 'percentage' ? 100 : undefined
        },
        {
          label: this.$i18n.t('ExtraFibersRule'),
          value: !this.editingData
           ? this.parseRadioValue(this.networkRuleData.subscriber_extra_mode, this.maintenanceFibersRuleOptions)
           : this.networkRuleData.subscriber_extra_mode,
          varName: 'subscriber_extra_mode',
          inputType: 'radio',
          disabled: false,
          required: false,
          size: '50%',
          radioOptions: this.maintenanceFibersRuleOptions,
        },
        {
          label: this.networkRuleData.subscriber_extra_mode === 'percentage'
            ? this.$i18n.t("PercentageOfFibers")
            : this.$i18n.t("NumberOfFibers"),
          value: this.networkRuleData.subscriber_extra_value,
          varName: 'subscriber_extra_value',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
          max: this.networkRuleData.subscriber_extra_mode === 'percentage' ? 100 : undefined
        },
        {
          label: !this.editingData ? this.$i18n.t("AllowSDUFibersMultipleSplitters") : '',
          value: !this.editingData
           ? this.networkRuleData.sdu_cross_splitter === true ? this.$i18n.t('Yes') : this.$i18n.t('No')
           : this.networkRuleData.sdu_cross_splitter,
          varName: 'sdu_cross_splitter',
          inputType: 'checkbox',
          disabled: false,
          required: false,
          size: '50%',
          checkboxOptions: [
            {
              id: 'allow_sdu_fibers',
              label: this.$i18n.t("AllowSDUFibersMultipleSplitters"),
            }
          ]
        },
        {
          label: !this.editingData ? this.$i18n.t("AllowMDUFibersMultipleSplitters") : '',
          value: !this.editingData
           ? this.networkRuleData.mdu_cross_splitter === true ? this.$i18n.t('Yes') : this.$i18n.t('No')
           : this.networkRuleData.mdu_cross_splitter,
          varName: 'mdu_cross_splitter',
          inputType: 'checkbox',
          disabled: false,
          required: false,
          size: '50%',
          checkboxOptions: [
            {
              id: 'allow_mdu_fibers',
              label: this.$i18n.t("AllowMDUFibersMultipleSplitters"),
            }
          ]
        },
        {
          label: !this.editingData ? this.$i18n.t("SDUUseSplitters") : '',
          value: !this.editingData
           ? this.networkRuleData.sdu_uses_splitter === true ? this.$i18n.t('Yes') : this.$i18n.t('No')
           : this.networkRuleData.sdu_uses_splitter,
          varName: 'sdu_uses_splitter',
          inputType: 'checkbox',
          disabled: false,
          required: false,
          size: '50%',
          checkboxOptions: [
            {
              id: 'sdu_splitters',
              label: this.$i18n.t("SDUUseSplitters"),
            }
          ]
        },
        {
          label: !this.editingData ? this.$i18n.t("MDUFibersP2P") : '',
          value: !this.editingData
           ? this.networkRuleData.mdu_point_2_point === true ? this.$i18n.t('Yes') : this.$i18n.t('No')
           : this.networkRuleData.mdu_point_2_point,
          varName: 'mdu_point_2_point',
          inputType: 'checkbox',
          disabled: false,
          required: false,
          size: '50%',
          checkboxOptions: [
            {
              id: 'mdu_p2p',
              label: this.$i18n.t("MDUFibersP2P"),
            }
          ]
        },
        {
          label: this.$i18n.t("MinimumHPsMDU"),
          value: this.networkRuleData.mdu_classifier,
          varName: 'mdu_classifier',
          inputType: 'number',
          disabled: false,
          required: false,
          size: '50%',
          step: '1',
          min: '0',
        },
      ]
    },

    maintenanceFibersRuleOptions() {
      return [
        { value: 'fixed', label: this.$i18n.t('Fixed') },
        { value: 'percentage', label: this.$i18n.t('Percentage') }
      ];
    },

    selectedTabFields() {
      switch (this.tabs[this.activeTab].id) {
        case "network_whole":
          return this.networkWholeFields;
        case "feeder_network":
          return this.feederNetworkFields;
        case "distribution_network":
          return this.distributionNetworkFields;
        case "drop_network":
          return this.dropNetworkFields;
        case "vertical_network":
          return this.verticalNetworkFields;
        case "subscribers":
          return this.subscribersFields;
        default:
          return [];
      }
    },

    selectedTabNetworkTier() {
      switch (this.activeTab) {
        case 1: // feeder network
          return 3
        case 2: // distribution network
          return 2
        case 3: // drop network
          return 1
        case 4: // vertical network
          return 5
        default:
          return null;
      }
    }
  },

  watch: {
    activeTab(value) {
      this.cableOptions = [];
      this.verticalAuxiliaryOptions = [];
      if(value !== 4){
        this.loadFamilyOptionsList("cableOptions", "ca", this.selectedTabNetworkTier);
      } else {
        this.loadFamilyOptionsList("cableOptions", "ca", 5);
        this.loadFamilyOptionsList("verticalAuxiliaryOptions", "ca", 6);
    }
  }
  },

  methods: {
    ...mapActions(["fetchStockMaterialsList"]),

    parseRadioValue(value, options) {
      let optionObject = options.find(option => option.value === value);
      return optionObject ? optionObject.label : '';
    },

    loadAllOptionsLists() {
      this.loadFamilyOptionsList("splitterOptions", "sp", this.selectedTabNetworkTier);
      this.loadFamilyOptionsList("closureOptions", "cl",  this.selectedTabNetworkTier);
    },

    async loadFamilyOptionsList(familyOptionsListName, familyID, selectedTabNetworkTier) {
      let queryParameters = !selectedTabNetworkTier
        ? this.getDataToSend(familyID)
        : this.getDataToSend(familyID, selectedTabNetworkTier);

      try {
        let materials = await this.fetchStockMaterialsList(queryParameters);
        if (materials.length > 0) {
          let list = this.normalizeMaterialOptionsList(materials);
          this[familyOptionsListName] = list;
        }
      } catch (error) {
        console.error(error);
      }
    },

    getDataToSend(familyID, tier = null) {
      let queryParameters = {
        material_family_id: familyID,
      };
      if (!!this.networkRuleId) {
        queryParameters["network_rules_template_id"] = this.networkRuleId;
      }
      if (familyID === "ca") {
        queryParameters["network_level_id"] = tier;
      }
      return queryParameters;
    },

    normalizeMaterialOptionsList(originalList) {
      let normalizedList = [];
      originalList.forEach(option => {
        normalizedList.push({
          code: option.sm_id,
          label: this.getMaterialOptionLabel(option)
        });
      });
      return normalizedList;
    },

    getMaterialOptionLabel(material) {
      let label = "";
      if (material.sm_short_description) {
        label = material.sm_short_description;
      } else if (
        material.sm_reference &&
        material.sm_description &&
        material.sm_reference === material.sm_description
      ) {
        label += material.sm_reference;
      } else {
        if (material.sm_reference) {
          label += material.sm_reference;
        }
        if (material.sm_reference && material.sm_description) {
          label += " - ";
        }
        if (material.sm_description) {
          label += material.sm_description;
        }
      }
      return label;
    },

    // includeInAllOption(options) {
    //   return [{ id: "all", label: "All", children: options }];
    // },
  }
}
</script>

<style scoped>
.network-rule-specific-info-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 17px 21px;
  flex: 1;
  position: relative;
  height: auto;
  max-height: 75%;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-end;
  position: absolute;
  right: 21px;
  bottom: 17px;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/SystemSettingsManagement/NetworkRules/NetworkRuleSpecificInfo.vue